import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Offers } from "./components/Offers";
import { Process } from "./components/Process";
import { About } from "./components/About";
import { ServiceArea } from "./components/ServiceArea";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const Landing = () => (
  <div className="App bg-[#050505] text-white min-h-screen overflow-x-hidden">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <Offers />
      <Process />
      <About />
      <ServiceArea />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
